module.exports = __webpack_public_path__ + "img/tr-arrange-icon.e46b57b4.svg";